<template>
  <div class="review-box">
    <img src="@/assets/images/content_review.png" alt="" />
    <div class="text">内容正在审核中，请稍后查看~</div>
    <router-link to="/list"><el-button type="primary">返回首页</el-button></router-link>
  </div>
</template>
<script>
export default {
  name: "detailReview"
};
</script>

<style scoped lang="less">
.review-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 100px;
  img {
    width: 200px;
  }
  .text {
    font-size: 16px;
    margin-top: 10px;
  }
  .el-button {
    width: 180px;
    margin-top: 40px;
  }
}
</style>
